import { forwardRef } from 'react';
import { MagnifyingGlassIcon } from '@radix-ui/react-icons';

import { comboboxEmptyStyles } from './combobox.styles';
import type { ComboboxEmptyProps } from './combobox.types';

export const ComboboxEmpty = forwardRef<HTMLDivElement, ComboboxEmptyProps>(
  ({ query, message, size = 'md', className }, ref) => {
    const defaultMessage = query ? `No results found for "${query}"` : 'No options available';

    return (
      <div ref={ref} className={comboboxEmptyStyles({ size, className })} role="status">
        <MagnifyingGlassIcon
          className="combobox-empty-icon h-8 w-8 text-gray-400"
          aria-hidden="true"
        />
        <p className="combobox-empty-message mt-2">{message || defaultMessage}</p>
      </div>
    );
  }
);

ComboboxEmpty.displayName = 'ComboboxEmpty';
